var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotSLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 49,
    viewBox: "0 0 90 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.1436 0.755497C74.1342 1.69032 71.2882 5.42961 71.2882 9.54283C71.2882 9.70902 71.2882 9.87522 71.309 10.0414C71.7037 17.4784 68.1098 24.4169 62.1269 28.4263C60.2988 29.6519 57.8891 29.6519 56.1025 28.3432C52.6333 25.8295 50.639 21.5501 51.2415 17.0422C51.3038 16.6475 51.3245 16.232 51.3245 15.8373C51.3245 10.8516 47.2736 6.80068 42.2879 6.80068C37.3022 6.80068 33.2513 10.8516 33.2513 15.8373C33.2513 16.232 33.2721 16.6475 33.3344 17.0422C34.1861 23.5029 29.7405 29.465 23.3214 30.4829C23.176 30.5036 23.0513 30.5036 22.9059 30.5036C21.5556 30.5036 20.2469 29.9012 19.3536 28.8625C18.3357 27.6784 17.9825 26.058 18.398 24.5623C18.9174 22.7134 18.8343 20.6776 18.1072 18.7664C16.9854 15.8789 14.3471 13.7599 11.2726 13.2406C4.39643 12.0772 -1.39947 18.7249 1.36345 25.7464C2.81762 29.4442 6.72311 31.5631 10.6701 31.1269H10.7532C10.9402 31.1061 11.1272 31.0853 11.2934 31.0853C12.6437 31.0853 13.9524 31.6877 14.8457 32.7264C15.8636 33.9105 16.2168 35.5309 15.8013 37.0266C15.739 37.2136 15.7182 37.4213 15.6766 37.6083C15.6559 37.7329 15.6143 37.8368 15.5935 37.9614C15.5104 38.46 15.4481 38.9586 15.4481 39.4572C15.4481 40.0804 15.5104 40.6828 15.6351 41.2853C16.4868 45.3985 20.1222 48.4938 24.4847 48.4938C28.8472 48.4938 32.4827 45.3985 33.3344 41.2853C33.459 40.7036 33.5214 40.0804 33.5214 39.4572C33.5214 39.0832 33.5006 38.7301 33.459 38.3769C33.459 38.3354 33.459 38.2938 33.459 38.2523C32.7735 33.0796 35.4949 28.2185 39.9197 25.9542C41.3947 25.2063 43.1397 25.2063 44.6146 25.9542C49.0394 28.1977 51.7608 33.0588 51.0753 38.2523C51.0129 38.647 50.9922 39.0625 50.9922 39.4572C50.9922 45.1492 56.2895 49.6363 62.21 48.2445C66.2194 47.3097 69.0654 43.5704 69.0654 39.4572C69.0654 39.291 69.0654 39.1248 69.0446 38.9586C68.5461 29.6311 74.3212 21.1139 83.1709 18.1224C86.2454 17.0837 89.3407 14.03 89.3407 9.54283C89.3615 3.8508 84.0641 -0.63635 78.1436 0.755497Z",
    fill: "url(#paint0_linear_585_1447)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_585_1447",
    x1: 75.5161,
    y1: -8.43547,
    x2: 18.6992,
    y2: 46.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1323,
    stopColor: "#5549AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#876FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6469,
    stopColor: "#D86F6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8159,
    stopColor: "#E28F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC363"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotSLogo);
export default __webpack_public_path__ + "static/media/botSLogo.81bc6f74d5b95565ca85eb4a94feaa8a.svg";
export { ForwardRef as ReactComponent };